import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { WelcomeQuestion } from "./questionTypes";
import { OptimizedImage } from "@/components/ui/optimized-image";
interface WelcomeScreenProps {
  question: WelcomeQuestion;
  onNext: () => void;
}
export function WelcomeScreen({
  question,
  onNext
}: WelcomeScreenProps) {
  return <div className="flex flex-col md:flex-row items-center justify-between gap-8 py-8 w-full max-w-4xl mx-auto min-h-[400px]">
      <div className="text-left space-y-6 w-full md:max-w-md flex-shrink-0">
        <h1 className="text-3xl font-bold text-foreground md:text-xl">
          Every succession plan is a unique journey.
          <br />
          Welcome to your mySuccession SnapShot
        </h1>
        
        <p className="text-muted-foreground text-base">
          {question.description}
        </p>
        
        <Button onClick={onNext} className="mt-4 bg-primary hover:bg-primary/90 px-5 py-2 h-auto">
          Let's get started
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
      
      <div className="flex-shrink-0 w-full max-w-md md:w-auto">
        <div className="relative">
          <OptimizedImage 
            src={question.image?.src || "/lovable-uploads/aca40bb5-698e-4c57-b26d-c9838c7e03b6.png"} 
            alt={question.image?.alt || "Assessment Illustration"} 
            width={300}
            height={300}
            priority={true}
            className="w-full h-auto max-w-[300px] object-contain" 
          />
        </div>
      </div>
    </div>;
}